import { GithubIcon, LinkedinFilledIcon } from 'assets/icons'
import { ResumeIcon } from 'assets/icons/User'
import { Button, Link } from 'components'
import React from 'react'
import { formatToDDMonthYear } from 'utils'

import { ArrowRightIcon } from '@radix-ui/react-icons'

import { ThunderIcon } from '../assets'
// import gfg from '../assets/images/gfg.png'
// import hackerrank from '../assets/images/hackerrank.png'
// import leetcode from '../assets/images/leetcode.png'
// import { useFetchUserIntegrations } from '../user.services'
import { User } from '../user.types'

const BasicDetailsV2 = ({
  user,
  isCurrentUser
}: {
  user: User
  isCurrentUser: boolean
}) => {
  // const { data: externalProfiles } = useFetchUserIntegrations()

  return (
    <div className="flex w-full flex-col bg-[#1A1A1E] p-6 gap-4 rounded-sm">
      <div className="flex flex-col gap-4">
        <div className="flex flex-row justify-between">
          <img
            src={user.image_url && user.image_url.replace('=s96-c', '')}
            alt="profile"
            className="object-center object-cover rounded-sm h-42 w-1/2"
          />

          <div className="flex flex-col gap-4">
            <div>
              <p className="text-zinc-100 font-bold text-base truncate">
                {user.name}
              </p>
              <p className="text-zinc-400">@{user.username}</p>
            </div>
            <div className="flex flex-row gap-2 items-center jsutify-start">
              <a href={user.github_url} target="_blank" rel="noreferrer">
                <GithubIcon className="w-7 h-7" />
              </a>
              <a href={user.linkedin_url} target="_blank" rel="noreferrer">
                <LinkedinFilledIcon className="w-7 h-7" />
              </a>
              <a href={user.resume_url} target="_blank" rel="noreferrer">
                <ResumeIcon className="w-7 h-7" />
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-4 items-start">
          {user.bio && (
            <>
              <p className="font-semibold text-base">Description : </p>
              <p className="text-[#DDDDDD] text-sm">{user.bio}</p>
            </>
          )}
          {isCurrentUser && (
            <Link href={`/u/${user.username}/settings`}>
              <Button
                className="flex gap-4 bg-primary-dark mt-2"
                rounded={'none'}>
                Edit Profile <ArrowRightIcon />
              </Button>
            </Link>
          )}
        </div>
      </div>
      {/* Streaks */}
      <div className="my-4 py-4 border-y-2 border-zinc-700">
        <p className="font-semibold flex flex-row gap-2 items-center">
          <span>
            <ThunderIcon className="w-4 h-4" />
          </span>
          <span> Streaks</span>
        </p>
        <div className="p-4">
          <table className="w-full">
            <tbody>
              <tr>
                <td className="text-[#C1C1C1]">Solved Question</td>
                <td className="font-medium">-</td>
              </tr>
              <tr>
                <td className="text-[#C1C1C1]">Challenges</td>
                <td className="font-medium">-</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* External Profiles */}
      {/* {externalProfiles &&
        (externalProfiles.gfg_user_name ||
          externalProfiles?.leetcode_user_name ||
          externalProfiles?.hackerrank_user_name) && (
          <div className="mb-2 py-2 border-b-2 border-zinc-700">
            <p className="font-semibold">Other Profiles</p>

            <div className="p-4 flex-col gap-4">
              {externalProfiles?.hackerrank_user_name && (
                <div className="flex items-center justify-start gap-4">
                  <div className="text-xs">
                    <img
                      src={hackerrank.src}
                      className="h-8 w-8"
                      alt="hackerrank"
                    />
                  </div>

                  <a
                    className="hover:text-primary"
                    href={`https://www.hackerrank.com/${externalProfiles?.hackerrank_user_name}`}
                    target="_blank"
                    rel="noreferrer">
                    Hackerrank
                  </a>
                </div>
              )}

              {externalProfiles?.leetcode_user_name && (
                <div className="flex items-center justify-start gap-4">
                  <div className="text-xs">
                    <img
                      src={leetcode.src}
                      className="h-8 w-8"
                      alt="leetcode"
                    />
                  </div>

                  <a
                    className="hover:text-primary"
                    href={`https://leetcode.com/${externalProfiles?.leetcode_user_name}`}
                    target="_blank"
                    rel="noreferrer">
                    Leetcode
                  </a>
                </div>
              )}

              {externalProfiles?.gfg_user_name && (
                <div className="flex items-center justify-start gap-4">
                  <div className="text-xs">
                    <img src={gfg.src} className="h-8 w-8" alt="gfg" />
                  </div>

                  <a
                    className="hover:text-primary"
                    href={`https://auth.geeksforgeeks.org/user/${externalProfiles?.gfg_user_name}`}
                    target="_blank"
                    rel="noreferrer">
                    GFG
                  </a>
                </div>
              )}
            </div>
          </div>
        )} */}

      {/* Personal Details */}
      <div className="mb-2 py-2 border-b-2 border-zinc-700">
        <p className="font-semibold">Personal Details</p>
        <div className="p-4 flex-col gap-2">
          {user.dob && (
            <div className="flex items-center gap-2">
              <div className="bg-primary-light w-4 h-4 rounded-full"></div>
              <div>{formatToDDMonthYear(user.dob)}</div>
            </div>
          )}

          {user.grad_specialization && (
            <div className="flex items-center gap-2">
              <div className="bg-primary-light w-4 h-4 rounded-full"></div>
              <div>{user.grad_specialization}</div>
            </div>
          )}

          {user.college_name && (
            <div className="flex items-center gap-2">
              <div className="bg-primary-light w-4 h-4 rounded-full"></div>
              <div>{user.college_name}</div>
            </div>
          )}

          {user.grad_start && (
            <div className="flex items-center gap-2">
              <div className="bg-primary-light w-4 h-4 rounded-full"></div>
              <div>{`${user.grad_start} - ${user.grad_end || 'Present'}`}</div>
            </div>
          )}
        </div>
      </div>

      {/* Group  Details */}
      <div className="mb-2 py-2 border-b-2 border-zinc-700">
        <p className="font-semibold">Team Details</p>
        <div className="p-4 flex-col gap-2">
          {user &&
          user.user_group_details &&
          user.user_group_details.length > 0 ? (
            user.user_group_details.map((group) => (
              <div key={group.slug} className="flex flex-col gap-1">
                <Link
                  className="hover:text-primary"
                  href={`/groups/${group.slug}`}>
                  {group.name}
                </Link>
                <div className="text-xs">({group.members_count} members)</div>
              </div>
            ))
          ) : (
            <div className="flex flex-col gap-1">--</div>
          )}
        </div>
      </div>
    </div>
  )
}

export default BasicDetailsV2
